export default function isTableExpanded(editor, tableId) {
  return Boolean(editor.getTableCells(tableId).getIn([0, 'data', 'isExpanded']));
}